<template>
    <b-container v-if="$can('view-sales-orders') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Sales Orders</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="recalc(); submittingRecalc = 1" v-if="this.tables.salesOrders.selected.length" :disabled="submittingRecalc == 1">
                            <span v-if="submittingRecalc">
                                <b-spinner small type="grow"></b-spinner>
                                Recalculating Orders...
                            </span>
                            <span v-else>Recalc</span>
                        </b-button>
                        <b-button v-if="$can('view-all') || $can('view-payments')" variant="outline-primary" size="sm" @click="openModal('receive-payment')">Receive
                            Payment</b-button>
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('apply-credit')">Apply Credit
                        </b-button> -->
                        <b-button variant="outline-primary" size="sm" :to="{ name: 'SalesOrdersCreate' }">New Sales Order
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('export-columns')">Export
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="exportLineItemsExcel">
                            <span v-if="exports.loadingLineItems">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Exporting Line Items...</strong>
                            </span>
                            <span v-else>Export Line Items</span>
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="exportSalesByItem">
                            <span v-if="exports.loadingSalesByItem">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Exporting Sales By Item...</strong>
                            </span>
                            <span v-else>Export Sales By Item</span>
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i
                                class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="2">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-form-input v-model="tables.salesOrders.filter" type="search" id="filterInput"
                                    placeholder="Type to Search" debounce="500"></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        :disabled="!tables.salesOrders.filter && !filters.selected.salesReps.length && !filters.selected.status.length && !filters.selected.paymentTypes.length && !filters.selected.tags.length && !filters.selected.dateFrom.length && !filters.selected.dateTo.length"
                                        @click="clearFilters">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="2">
                        <b-form-datepicker id="input-date-from" v-model="filters.selected.dateFrom"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class="mb-2"
                            placeholder="From" today-button close-button reset-button @input="filterSelect($event, 'dateFrom')" :disabled="filters.selected.dateFilter != null">
                        </b-form-datepicker>
                    </b-col>

                    <b-col cols="2">
                        <b-form-datepicker id="input-date-to" v-model="filters.selected.dateTo"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class="mb-2"
                            placeholder="To" today-button close-button reset-button @input="filterSelect($event, 'dateTo')" :disabled="filters.selected.dateFilter != null">
                        </b-form-datepicker>
                    </b-col>

                    <b-col>
                        <treeselect name="filtersDateFilterSelect" class="filters-date-filter-select" clearable :searchable="false" open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Period" :options="filters.dateFilters"
                            @input="filterSelect($event, 'dateFilter')" :value="filters.selected.dateFilter" ref="selectDateFilter" />
                    </b-col>

                    <b-col>
                        <treeselect name="filtersStatusSelect" class="filters-status-select" clearable
                            :searchable="false" open-on-click clear-on-select close-on-select disableBranchNodes
                            placeholder="Status" :options="filters.status" @input="filterSelect($event, 'status')"
                            :value="filters.selected.status" multiple ref="selectStatus" />
                    </b-col>

                    <b-col>
                        <treeselect name="filtersSalesRepsSelect" class="filters-sales-reps" clearable
                            :searchable="false" open-on-click clear-on-select close-on-select disableBranchNodes
                            placeholder="Sales Reps" :options="filters.salesReps"
                            @input="filterSelect($event, 'salesReps')" multiple ref="selectSalesReps" />
                    </b-col>

                    <b-col>
                        <treeselect name="filtersPaymentTypes" class="filters-payment-types" clearable
                            :searchable="false" open-on-click clear-on-select close-on-select disableBranchNodes
                            placeholder="Payment Types" :options="filters.paymentTypes"
                            @input="filterSelect($event, 'paymentTypes')" multiple ref="selectPaymentTypes" />
                    </b-col>

                    <b-col>
                        <treeselect name="filtersTags" class="filters-tags" clearable :searchable="false" open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Tags"
                            :options="filters.tags" @input="filterSelect($event, 'tags')" multiple ref="selectTags" />
                    </b-col>
                    <b-col cols="1">
                        <b-form-group>
                            <b-form-select v-model="tables.salesOrders.perPage" id="perPageSelect" size="sm"
                                :options="tables.salesOrders.pageOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-sales-orders-table">
                    <b-container fluid>
                        <b-table v-if="tables.salesOrders.ready" :key="tables.salesOrders.key"
                            class="sales-orders-table" responsive bordered striped hover no-border-collapse
                            sticky-header="calc(100vh - 250px)" head-variant="light" :items="tables.salesOrders.items"
                            :fields="visibleFields" :sort-by="tables.salesOrders.sortBy"
                            :sort-desc="tables.salesOrders.sortDesc" :per-page="tables.salesOrders.perPage"
                            :current-page="tables.salesOrders.currentPage" :filter="tables.salesOrders.filter"
                            @filtered="onFiltered" :busy="tables.salesOrders.isBusy">

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:head(checkbox)="row">
                                <b-form-checkbox v-model="tables.salesOrders.allSelected" @change="toggleAll">
                                </b-form-checkbox>
                            </template>

                            <template v-slot:cell(checkbox)="row">
                                    <b-form-checkbox :value="row.item.id" v-model="tables.salesOrders.selected" />
                                </template>

                            <template v-slot:cell(id)="row">
                                <b-link :ref="'ordersTableRow' + row.item.id"
                                    @click="saveState('ordersTableRow' + row.item.id)" :to="{name: 'SalesOrderDetail', params: { soNum: row.item.sales_order_number } }">{{ row.item.id }}
                                </b-link>
                            </template>

                            <template v-slot:cell(sales_order_number)="row">
                                <b-link :ref="'ordersTableRow' + row.item.id"
                                    @click="saveState('ordersTableRow' + row.item.id)"
                                    :to="{name: 'SalesOrderDetail', params: { soNum: row.item.sales_order_number } }">{{
                                    row.item.sales_order_number }}</b-link>
                            </template>

                            <template v-slot:cell(customer)="row">
                                <b-link v-if="row.item.customer" :to="{name: 'CustomerDetail', params: { id: row.item.customer.id } }">{{
                                row.item.customer.name }}</b-link>
                            </template>

                            <template v-slot:cell(net_total)="row">
                                <span>${{ numberWithCommas(row.item.subtotal - row.item.discount_total - row.item.credit_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(cogs)="row">
                                <div v-if="($can('view-all') || $can('view-product-cost'))">
                                    <span v-if="row.item.status == 'Closed'">${{ numberWithCommas(row.item.cogs) }}</span>
                                    <span v-else>N/A</span>
                                </div>
                            </template>

                            <template v-slot:cell(credit_total)="row">
                                <span>${{ numberWithCommas(row.item.credit_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(discount_total)="row">
                                <span>${{ numberWithCommas(row.item.discount_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(shipping_total)="row">
                                <span>${{ numberWithCommas(row.item.shipping_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(total)="row">
                                <span>${{ numberWithCommas(row.item.total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(sales_rep)="row">
                                <span v-if="row.item.sales_rep">{{ row.item.sales_rep.name }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(sale_order_tag)="row">
                                <span v-if="row.item.sale_order_tag">
                                    <b-badge v-for="(tag, index) in row.item.sale_order_tag" :key="index" pill
                                        variant="secondary" class="tag-badges">{{ tag.orders_tag.name }}</b-badge>
                                </span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click="openModal('listing', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="showMsgBoxDeleteConfirm('invoices', row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                        <!-- <b-col>
                                            <b-link @click=""><i class="far fa-check-square"></i></b-link>
                                        </b-col> -->
                                        <b-col>
                                            <b-link
                                                :to="{name: 'SalesOrderDetail', params: { soNum: row.item.sales_order_number } }">
                                                <i class="fas fa-edit"></i>
                                            </b-link>
                                        </b-col>
                                        <!-- <b-col>
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination v-model="tables.salesOrders.currentPage"
                            :total-rows="tables.salesOrders.totalRows" :per-page="tables.salesOrders.perPage"
                            align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>

                <modal-receive-payment v-if="modals['receive-payment'].active" />

                <modal-apply-credit v-if="modals['apply-credit'].active" />

                <modal-adjust-columns v-if="modals['adjust-columns'].active" :fields="modals['adjust-columns'].fields"
                    @saveColSaves="saveColSaves" />

                <modal-export-columns v-if="modals['export-columns'].active" :fields="modals['export-columns'].fields"
                    :ignores="modals['export-columns'].ignores" @exportExcel="exportExcel" />

                <modal-export-line-items v-if="modals['export-line-items'].active" />
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
    import store from '../../../store'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalReceivePayment from '../lists/customers/modals/ReceivePayment'
    import ModalApplyCredit from '../lists/customers/modals/ApplyCredit'
    import ModalAdjustColumns from '../common/modals/AdjustColumns'
    import ModalExportColumns from '../common/modals/ExportColumns'
    import ModalExportLineItems from '../common/modals/ExportLineItems'
 	export default {
    	name: 'SalesOrders',

        metaInfo() {
            return {
                title: 'Orders',
            }
        },

    	components: {
      		Treeselect,
            'modal-receive-payment': ModalReceivePayment,
            'modal-apply-credit': ModalApplyCredit,
            'modal-adjust-columns': ModalAdjustColumns,
            'modal-export-columns': ModalExportColumns,
            'modal-export-line-items': ModalExportLineItems
    	},
        data() {
            return {
                modals: {
                    'create-sales-order': {
                        create: {
                            active: 1
                        },
                        key: 1,
                        submitting: 0,
                        statusSelected: []
                    },

                    'edit-sales-order': {
                        edit: [],
                        key: 1,
                        submitting: 0
                    },

                    'receive-payment': {
                        active: 0
                    },

                    'apply-credit': {
                        active: 0
                    },

                    'adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['checkbox', 'actions']
                    },

                    'export-line-items': {
                        active: 0
                    }
                },
                tables: {
                    salesOrders: {
                        selected: [],
                        allSelected: false,
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'date',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userfields: [],
                        fields: [
                            {
                                key: 'checkbox',
                                label: '',
                                visible: 1
                            },
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sales_order_number',
                                label: 'Sales Order #',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'customer',
                                label: 'Customer Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'credit_total',
                                label: 'Credits',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'shipping_total',
                                label: 'Shipping Fee',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'discount_total',
                                label: 'Discounts',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'net_total',
                                label: 'Net Total',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'status',
                                label: 'Status',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                sortable: true,
                                visible: 1
                            },
                            // {
                            //     key: 'customer.balance',
                            //     label: 'Total Balance',
                            //     sortable: true,
                            //     formatter: value => {
                            //         return '$' + this.numberWithCommas(value)
                            //     },
                            //     visible: 1
                            // },
                            {
                                key: 'balance',
                                label: 'Balance Due',
                                sortable: true,
                                formatter: value => {
                                    return '$' + this.numberWithCommas(value)
                                },
                                visible: 1
                            },
                            {
                                key: 'cogs',
                                label: 'COGS',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'source',
                                label: 'Source',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'date',
                                label: 'Order Placed',
                                sortable: true,
                                thClass: 'sales-orders-table-style-datetime',
                                visible: 1
                            },
                            {
                                key: 'date_shipped',
                                label: 'Order Shipped',
                                sortable: true,
                                thClass: 'sales-orders-table-style-datetime',
                                visible: 1
                            },
                            {
                                key: 'payment_method',
                                label: 'Payment Type',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sales_rep',
                                label: 'Sales Rep',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sale_order_tag',
                                label: 'Tags',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'sales-orders-table-style-actions',
                                visible: 1
                            }
                        ],

                        items: [],
                        categories: [],
                        ready: 0
                    },
                },

                filters: {
                    selected: {
                        dateFrom: '',
                        dateTo: '',
                        dateFilter: null,
                        salesReps: [],
                        status: [],
                        paymentTypes: [],
                        tags: []
                    },
                    salesReps: [],
                    status: [
                        {
                            id: 'Open',
                            label:'Open'
                        },
                        {
                            id: 'Pending',
                            label:'Pending'
                        },
                        {
                            id: 'Confirmed',
                            label:'Confirmed'
                        },
                        {
                            id: 'Dispatched',
                            label:'Dispatched'
                        },
                        {
                            id: 'Closed',
                            label:'Closed'
                        },
                        {
                            id: 'Cancelled',
                            label:'Cancelled'
                        }
                    ],
                    paymentTypes: [
                        {
                            id: 'Due on Receipt',
                            label:'Due on Receipt'
                        },
                        {
                            id: 'Net 30',
                            label:'Net 30'
                        },
                        {
                            id: 'COD MO',
                            label:'COD MO'
                        },
                        {
                            id: 'COD CC',
                            label:'COD CC'
                        },
                        {
                            id: 'Credit Card',
                            label:'Credit Card'
                        }
                    ],
                    tags: [],
                    dateFilters: [
                        {
                            id: 'Last 7 Days',
                            label: 'Last 7 Days'
                        },
                        {
                            id: 'Last 30 Days',
                            label: 'Last 30 Days'
                        },
                        {
                            id: 'This Month',
                            label: 'This Month'
                        },
                        {
                            id: 'Year To Date',
                            label: 'Year To Date'
                        },
                        {
                            id: 'Last Month',
                            label: 'Last Month'
                        },
                        {
                            id: 'Last Year',
                            label: 'Last Year'
                        },
                        {
                            id: 'Last 365',
                            label: 'Last 365'
                        }
                    ]
                },

                exports: {
                    cols: [],
                    loadingLineItems: false,
                    loadingSalesByItem: false,
                },

                submittingRecalc: 0
            }
        },
        methods: {
            recalc() {
                let url = 'api/orders/sales-orders/recalculatebatch'
                axios.post(url, {
                    ids: this.tables.salesOrders.selected
                })
                    .then((res) => {
                        this.tables.salesOrders.selected = []
                        this.getSalesOrders(1)
                        this.showAlertBox('success', 'Order(s) Recalculated', 'Order(s) recalculated successfully!')
                        this.submittingRecalc = 0
                    }, () => {
                        this.has_error = true
                    })
            },

            toggleAll() {
                this.tables.salesOrders.selected = []

                if (this.tables.salesOrders.allSelected) {
                    for (let order in this.tables.salesOrders.filteredItems) {
                        this.tables.salesOrders.selected.push(this.tables.salesOrders.filteredItems[order].id.toString())
                    }
                }
            },

            exportExcel(cols, keys) {
                let url = 'api/exports/generateexport'
                axios.post(url, {
                    rows: this.objFilter(this.tables.salesOrders.filteredItems, keys),
                    table: 'salesOrders',
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            exportLineItemsExcel() {
                this.exports.loadingLineItems = true;
                axios.post('api/orders/sales-orders/exportlineitems', {
                    rows: this.tables.salesOrders.filteredItems
                }, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'line_items_export.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    console.error('Error exporting line items:', error);
                })
                .finally(() => {
                    this.exports.loadingLineItems = false;
                });
            },

            exportSalesByItem() {
                this.exports.loadingSalesByItem = true;
                axios.post('api/orders/sales-orders/exportsalesbyitem', {
                    rows: this.tables.salesOrders.filteredItems
                }, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales_by_item_export.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    console.error('Error exporting sales by item:', error);
                })
                .finally(() => {
                    this.exports.loadingSalesByItem = false;
                });
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Sales_Orders_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
            },

            clearFilters() {
                this.tables.salesOrders.filter = ''
                this.filters.selected.dateTo = ''
                this.filters.selected.dateFrom = ''
                this.$refs.selectStatus.clear()
                this.$refs.selectSalesReps.clear()
                this.$refs.selectDateFilters.clear()
                this.$refs.selectPaymentTypes.clear()
                this.$refs.selectTags.clear()
            },

            openModal(modalName, row) {
                let prefix = 'modal-inventory-sales-orders-'
                switch (modalName) {
                    case 'edit-sales-order':
                        this.modals[modalName].edit = Object.assign({}, row)
                        // this.setCurrentUserRoles(row.roles)

                        break

                    case 'receive-payment':
                        this.modals[modalName].active = 1

                        break

                    case 'apply-credit':
                        this.modals[modalName].active = 1

                        break

                    case 'adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.tables.salesOrders.userFields ? JSON.parse(JSON.stringify(this.tables.salesOrders.userFields)) : JSON.parse(JSON.stringify(this.tables.salesOrders.fields))

                        break

                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.salesOrders.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break

                    case 'export-line-items':
                        this.modals[modalName].active = 1

                        break;
                }

                if (modalName == 'receive-payment' || modalName == 'apply-credit') {
                    prefix = 'modal-lists-customers-'
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns' || modalName == 'export-line-items') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy() {
                this.tables.salesOrders.isBusy = !this.tables.salesOrders.isBusy
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedOrder.name && this.rememberedOrder.page) {
                        this.tables.salesOrders.currentPage = this.rememberedOrder.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedOrder.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            saveState(name) {
                let page = this.tables.salesOrders.currentPage
                let filter = this.tables.salesOrders.filter
                let perPage = this.tables.salesOrders.perPage
                let rowFilters = this.tables.salesOrders.rowFilters
                this.setRememberOrder({name: name, page: page, filter: filter, perPage: perPage, rowFilters: rowFilters })
            },

            getSalesOrders(silent) {
                if (!silent) {
                    this.tables.salesOrders.ready = 0
                    this.tables.salesOrders.filter = this.rememberedOrder.filter
                    this.tables.salesOrders.perPage = this.rememberedOrder.perPage
                    this.tables.salesOrders.rowFilters = this.rememberedOrder.rowFilters

                    this.toggleBusy()
                }

                let authGuard = {
                    isAdmin: this.$can('view-all'),
                    viewSelfOnly: this.$can('view-sales-order-self'),
                    authName: store.state.auth.user.name
                }

                let url = 'api/orders/sales-orders/getsalesorders'
                axios.post(url, {
                    filters: this.filters.selected,
                    authGuard: authGuard
                })
                .then((res) => {
                    this.tables.salesOrders.items = res.data.orders

                    // if (!silent) {
                        // if (!this.tables.salesOrders.filteredItems.length) {
                            this.tables.salesOrders.filteredItems = res.data.orders
                        // }
                        this.tables.salesOrders.totalRows = this.tables.salesOrders.items.length
                    if (!silent) {
                        this.tables.salesOrders.ready = 1
                        this.toggleBusy()

                        this.setLastState()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            filterSelect(name, area) {
                this.filters.selected[area] = name
                this.getSalesOrders(1)

                if (area == 'dateFilter') {
                    this.filters.selected.dateFrom = ''
                    this.filters.selected.dateTo = ''
                }
            },

            findCategoryName(id) {
                let index = this.findIndex(this.tables.salesOrders.status, 'id', id)
                return this.tables.salesOrders.status[index].label
            },

            getCategories() {
                let url = 'api/orders/sales-orders/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.salesOrders.status = res.data.categories
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.salesOrders.totalRows = filteredItems.length
                this.tables.salesOrders.currentPage = 1
                this.tables.salesOrders.filteredItems = filteredItems
            },

            getSalesRepsFilter() {
                let url = 'api/lists/sales-reps/getsalesrepsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.filters.salesReps = res.data.salesReps
                }, () => {
                    this.has_error = true
                })
            },

            getOrderTagsFilter() {
                let url = 'api/orders/sales-orders/getordertagsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.filters.tags = res.data.tags
                }, () => {
                    this.has_error = true
                })
            },

            processStatusQueryRoute(status) {
                if (status == 'create') {
                    this.$router.push({ name: 'SalesOrdersCreate' })
                } else {
                    this.filters.selected.status = []
                    if (status) {
                        if (status == 'confirmed') {
                            this.filters.selected.status.push('Confirmed')
                        } else if (status == 'dispatched') {
                            this.filters.selected.status.push('Dispatched')
                        }
                    }
                }
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/salesorders'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            if (res.data.colSaves.column_array.length == this.tables.salesOrders.fields.length) {
                                this.tables.salesOrders.userFields = res.data.colSaves.column_array
                            }
                        }

                        this.getSalesOrders()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                this.tables.salesOrders.userFields = fields
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'salesorders',
                    fields: fields.map(e => ({key:e.key, visible:parseInt(e.visible), label:e.label}))
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.salesOrders.ready = 0
                let tempFields = this.tables.salesOrders.fields
                this.tables.salesOrders.fields = []
                this.$nextTick(() => {
                    this.tables.salesOrders.fields = tempFields
                    this.tables.salesOrders.ready = 1
                })
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.salesOrders.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.salesOrders.totalRows
                let currentPage = this.tables.salesOrders.currentPage
                let perPage = this.tables.salesOrders.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.salesOrders.totalRows + ' rows'
            },

            visibleFields() {
                let userFields = this.tables.salesOrders.userFields
                if (userFields) {
                    let fields = this.tables.salesOrders.fields

                    return fields.filter(field => {
                        let index = this.findIndex(userFields, 'key', field.key)
                        if (userFields[index].visible) {
                            return true
                        }
                    })
                } else {
                    return this.tables.salesOrders.fields
                }
            }
	    },
	    mounted() {
            this.getColSaves()
            this.getSalesRepsFilter()
            this.getOrderTagsFilter()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-sales-orders-edit-sales-order':
                        this.modals['edit-sales-order'].edit = []

                        break
                    case 'modal-inventory-sales-orders-create-sales-order':
                        this.modals['create-sales-order'].create = {}

                        break
                    case 'modal-lists-customers-receive-payment':
                        this.modals['receive-payment'].active = 0

                        break
                    case 'modal-lists-customers-apply-credit':
                        this.modals['apply-credit'].active = 0

                        break
                    case 'modal-common-adjust-columns':
                        this.modals['adjust-columns'].active = 0
                        this.modals['adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                    case 'modal-common-export-line-items':
                        this.modals['export-columns'].active = 0

                        break
                }
            })

            // pusher
            Echo.channel('order-details-updated')
                .listen('OrderDetailsUpdated', (e) => {
                    this.getSalesOrders(1)
                })

            this.processStatusQueryRoute(this.$route.params.status)
	    },

        created() {

        },

        watch: {
            $route(to, from) {
                let status = to.params.status
                if (status) {
                    this.processStatusQueryRoute(to.params.status)
                } else {
                    this.filters.selected.status = []
                    this.getSalesOrders(1)
                }
            }
        }
    }
</script>
<style lang="scss">
    .buttons-create {

    }

    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .sales-orders-table {
        height: 75vh;
        font-size: 9pt;

        .sales-orders-thumbs {
            width: 80px;
            max-height: 80px;
        }

        .sales-orders-table-style-actions {
            // width: 120px;

            .actions-icons {
                text-align: center;
            }
        }

        .sales-orders-table-style-datetime {
            width: 110px;

            .actions-icons {
                text-align: center;
            }
        }

        .tag-badges {
            margin: 2px;
            padding: 5px;
        }
    }
</style>
